var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":"report-chart","height":_vm.Info.Chart.Height}},[_vm._v(" Your browser does not support chart. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }